const commonFieldNames = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'E-mail',
  businessPhone: 'Business Phone',
  mobilePhone: 'Mobile Phone',
};

/* for new users field info */
export const contactFieldNames = {
  ...commonFieldNames,
};

export const leadFieldNames = {
  ...commonFieldNames,
};

export const accountFieldNames = {
  accountName: 'Account Name',
  phone: 'Phone',
};

/* for existing clients field info */
export const opportunityFieldNames = {
  topic: 'Topic',
};

export const caseFieldNames = {
  caseTitle: 'Case Title',
  customer: 'Customer',
};

export const entityFields = {
  account: accountFieldNames,
  contact: contactFieldNames,
  lead: leadFieldNames,
  case: caseFieldNames,
  opportunity: opportunityFieldNames,
};
